import styled from "styled-components";
export const GeneralStyle = styled.div`
  position: relative;
  align-items: center;
  justify-self: ${({ questionBank }) => (questionBank ? "" : "center")};
  display: grid;
  ${({ isDependent, theme }) =>
    isDependent && `border-left: ${theme.primary.blue} solid !important;`}
  margin: ${({ questionBank }) => (questionBank ? "1em 0" : "1em")};
  max-width: 710px;
  grid-template-columns: ${({ questionBank }) =>
    questionBank ? "100%" : "minmax(650px, 710px)"};
  font-size: 14px;
  border-radius: 5px;
  padding: ${({ questionBank }) => (questionBank ? "0" : "1em 2em")};
  word-break: break-word;
  opacity: 0.95;
  box-shadow: ${({ editable }) =>
    editable && "0px 0px 10px rgba(0, 0, 0, 0.3);"};
  border-radius: 4px;
  background: ${(props) =>
    props.colorBackground === "#f9f9f9"
      ? "transparent"
      : props.colorBackground};
  @media only screen and (max-width: 768px) {
    grid-template-columns: 100%;
    justify-self: "";
    width: 100%;
  }
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }

  h2 {
    text-align: left;
    color: ${({ theme }) => theme.neutral.black};
    margin: 0 0 15px 15px;
    font-size: 14px;
  }
  :hover .overlay-option {
    opacity: 1;
  }
  .overlay-option {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(46, 46, 46, 0.2);
  }

  .bottom-buttons {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    @media only screen and (max-width: 475px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  }
`;

export const EditSection = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr;
  font-size: 14px;
  border-radius: 5px;
  word-break: break-word;
  background: "#f9f9f9";
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const UpperWrapper = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr;
  align-items: center;
  grid-gap: 1em;

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.text.secondary};
  }

  input::placeholder {
    font-size: 12px;
  }

  #mText {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const VSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  align-items: center;
  grid-template-rows: 1em;
  margin: 15px 0;
  @media only screen and (max-width: 495px) {
    grid-template-columns: 1fr;
  }
  input {
    justify-self: left;
    height: 25px;
    width: 100%;
    border: 1px solid rgba(240, 240, 240, 1);
    background: RGBA(250, 250, 250, 1);
    outline: none;
    padding: 1em 0.5em;
    font-size: small;
    border-radius: 3px;
  }

  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    width: auto;
    justify-self: flex-start;
    align-self: center;
  }

  div {
    grid-column: 3;
    margin-top: 0.5em;
  }

  .MuiFormControlLabel-root svg {
    height: 15px;
    width: 15px;
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.primary.purple};
  }
`;

export const ContentLabelStyle = styled.div`
  input[type="text"] {
    font-family: ${(props) =>
    props.styleLabel ? props.styleLabel.fontFamily : ""};
    color: ${(props) => (props.styleLabel ? props.styleLabel.color : "")};
    font-size: ${(props) =>
    props.styleLabel ? props.styleLabel.fontSize : ""};
    font-weight: ${(props) =>
    props.styleLabel ? props.styleLabel.fontWeight : ""};
    font-style: ${(props) =>
    props.styleLabel ? props.styleLabel.fontStyle : ""};
    text-decoration: ${(props) =>
    props.styleLabel ? props.styleLabel.textDecoration : ""};
  }
`;

export const QuestionWrapper = styled.div`
  display: block;
  padding: 0.4em;
  align-items: center;

  label {
    font-weight: 700;
  }

  textarea {
    padding: 1rem;
    width: 100%;
    height: 6em;
    outline: 0;
    border: none;
    background: ${({ theme }) => theme.neutral.gray[100]};
    border-radius: 4px;
    box-sizing: border-box;
    font-size: small;
    color: ${({ theme }) => theme.text.secondary};
    resize: none;
  }
`;
export const SelectsSection = styled.div`
  display: grid;
  padding: 0.4em;
  grid-gap: 1em;

  label {
    font-weight: 700;
    font-size: small;
  }
`;
export const QuestionPosition = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  align-content: center;

  div {
    display: grid;
    background: RGBA(250, 250, 250, 1);
    justify-content: center;
    align-content: center;
    height: 100%;
    border: 1px solid rgba(240, 240, 240, 1);
  }

  input {
    border: 1px solid rgba(240, 240, 240, 1);
    border-radius: 0px 3px 3px 0;
    font-weight: 700;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    opacity: 1;
  }
`;
export const LowerWrapper = styled.div`
  display: grid;
  padding: 0.4em;
  align-items: center;
  justify-content: stretch;

  .answer {
    pointer-events: ${({ editable }) => (editable ? "auto" : "none")};
    background: ${({ editable, theme }) => (editable ? theme.neutral.gray[900] : "transparent")};
  }

  .other {
    pointer-events: none;
    background: ${({ theme }) => theme.neutral.gray[900]};
  }
`;

export const RowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2em 2em;
  margin-bottom: 1em;
`;

export const AddAndRemove = styled.button`
  display: ${({ alreadySaved }) => (alreadySaved ? "none" : "inline-grid")};
  border: 0;
  background: RGBA(73, 73, 73, 1);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  align-self: center;
  justify-self: center;

  svg {
    align-self: center;
    width: 100% !important;
    transform: scale(4);
    fill: ${({ theme }) => theme.neutral.white};
  }
`;

export const ReqField = styled.span`
  color: ${({ theme }) => theme.primary.red};
  font-size: small;
  font-weight: 400 !important;
`;

export const PreviewWrapper = styled.label`
  font-weight: 700 !important;
  margin-left: 22px;
`;

export const ContainerTitle = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.neutral.gray[3200]};
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 15px;
`;
export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  @media only screen and (max-width: 495px) {
    flex-direction: column;
    align-items: center;
  }
  .left-container {
    margin-left: 20px;
    display: flex;
    width: 70%;
    @media only screen and (max-width: 495px) {
      width: fit-content;
    }
  }
  .right-container {
    display: flex;
    width: 30%;
    justify-content: end;
  }
`;
export const OtherOptionButtons = styled.a`
  padding-left: 3.5rem;
  &:hover {
    cursor: pointer !important;
  }
`;

export const EditButton = styled.button`
  background: ${({ theme }) => theme.primary.purple};
  border-radius: 4px;
  border: none;
  float: right;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.white};
  max-width: 80px;
  max-height: 31px;
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const DeleteButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.gray[2300]};
  float: right;
  font-size: 14px;
  font-weight: 500;
  max-width: 80px;
  max-height: 31px;
  &:hover {
    opacity: 0.9;
  }
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;
export const CloneButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  height: 31px;
  max-height: 31px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.black};
  float: left;
  font-size: 14px;
  font-weight: 500;
  max-width: 90px;
  left: 0;
  position: absolute;
  &:hover {
    opacity: 0.9;
  }
  svg {
    width: auto !important;
    height: auto !important;
  }
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;
export const SaveToBank = styled.button`
  background: ${({ theme }) => theme.primary.purple};
  border-radius: 4px;
  border: none;
  float: left;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.neutral.white};
  max-width: 110px;
  max-height: 31px;
  position: absolute;
  left: 120px;
  @media only screen and (max-width: 475px) {
    position: static;
    font-size: 12px;
  }
`;

export const TooltipCheckSection = styled.div`
  input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
    width: auto;
    justify-self: flex-start;
    align-self: center;
  }

  .MuiFormControlLabel-root svg {
    height: 20px;
    width: 20px;
    color: ${({ theme }) => theme.neutral.black};
  }

  .MuiFormControlLabel-label {
    font-size: 13px;
    font-weight: bold;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.neutral.black};
  }
`;

export const TooltipDescriptionContainer = styled.div`
  textarea {
    justify-self: left;
    height: 2em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    background: ${({ theme }) => theme.neutral.white};
    outline: none;
    padding: 1em 0.5em;
    font-size: small;
    border-radius: 3px;
  }
`;
